module.exports = __webpack_public_path__ + "assets/img/logo_footer.527f7525.png";